import PropTypes from 'prop-types'
import useAuth from '@/hooks/useAuth'
import FeatureUnavailable from '@/pages/FeatureUnavailable'
import {
    isFeatureFlagEnabled,
    ORG_FEATURE_FLAGS
} from '@/features/dashboard/site-admin/orgFeatureFlags'

/**
 * Blocks a route unless the active organisation has the named feature flag
 * explicitly enabled. Opt-in (fail-closed): a missing/false flag blocks access,
 * the inverse of BillingGuard's fail-open behaviour.
 */
const FeatureFlagGuard = ({ flag, children }) => {
    const { activeOrg } = useAuth()

    if (!isFeatureFlagEnabled(activeOrg, flag)) {
        const featureName =
            ORG_FEATURE_FLAGS.find((entry) => entry.key === flag)?.label ?? flag
        return <FeatureUnavailable featureName={featureName} />
    }

    return <>{children}</>
}

FeatureFlagGuard.propTypes = {
    flag: PropTypes.string.isRequired,
    children: PropTypes.node
}

export default FeatureFlagGuard
